module.exports = __webpack_public_path__ + "static/img/deflault_load.0accee0d.png";